import { ElementType } from 'react';
import CustomTooltip from 'Components/Form/CustomTooltip/CustomTooltip';
import { DatePicker } from 'antd';
import { NewLoadVisibilityFlags, ToggleVisibilityParams } from 'Shared/Types/form';
import styles from 'Components/Form/CustomInput/CustomInput.module.scss';

const CustomDatePicker = ({
  field,
  fieldName,
  visibilityToggler: toggleVisibility,
  visibilityFlagValue,
  placeholder = '',
  suffix: Suffix,
  error = {},
}: {
  field: any;
  fieldName: string;
  visibilityToggler: (params: ToggleVisibilityParams) => void;
  visibilityFlagValue: boolean;
  placeholder?: string;
  suffix?: ElementType;
  error?: any;
}) => {
  const flagName = fieldName as keyof NewLoadVisibilityFlags;

  return (
    <CustomTooltip error={error}>
      <DatePicker
        id={fieldName}
        className={styles.input}
        suffixIcon={Suffix ? <Suffix className={styles.input__icon} /> : ''}
        open={visibilityFlagValue}
        status={error.message ? 'warning' : ''}
        format="MM-DD-YYYY HH:mm:ss"
        placeholder={placeholder}
        showTime
        showNow={false}
        onClick={() => toggleVisibility({ flagName })}
        onOk={() => toggleVisibility({ flagName })}
        onKeyDown={(event) =>
          (event.key === 'Enter' || event.key === 'Escape') &&
          toggleVisibility({
            flagName,
            setToFalse: true,
          })
        }
        {...field}
      />
    </CustomTooltip>
  );
};

export default CustomDatePicker;
